import axios from 'axios'
import { apiVersion } from '../versions'
import { getJwt } from '../utils/authentication'

const baseURL = `/api/${apiVersion}`
export const $api = axios

export const getUrlWithVersion = (url: string) => baseURL + url
export const getUrl = (url: string) => '/api' + url
export const getHeaders = (data?: any) => ({
    Authorization: `Bearer ${getJwt()}`,
    ...data,
})
export const maxRequestTime = 1000 * 15
